import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import {
  HOME_ONE_SERP,
  SERP_PRODUCT_DETAIL_CLICK,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindDynamicEventsTracking } from 'shared/experiments/utils/tracking'
import store from 'shared/store'

export default () => {
  const { pageType } = store.getPublicRuntimeConfig()?.pageProperties || {}
  const { isEnabled } = getExperimentOnClient(HOME_ONE_SERP)

  if (pageType !== PAGE_TYPE_SEARCH_RESULTS || !isEnabled) {
    return
  }

  void activateExperiment(HOME_ONE_SERP)

  const trackEvents = () => {
    bindDynamicEventsTracking([
      {
        parentElementSelector:
          '[data-clientside-hook~="algoliaSearchListContainer"]',
        selector:
          '.o-SearchProductListItem__image, .o-SearchProductListItem__content__header__top, .o-SearchProductListItem__selectableSection > a, .o-SearchProductListItem__content__body > a',
        trackingEvent: SERP_PRODUCT_DETAIL_CLICK,
      },
    ])
  }

  trackEvents()
}
